import {
  SaleTypeName,
  TargetTemplateType,
  TargetTypes,
} from "@/modules/targets/types";

export const commonStyles = {
  borderBottom: "1px solid #D1D4D9",
  padding: 8,
};

export const defaultTargetsDetailsColumns = [
  {
    Header: "ID",
    accessor: "lead.journeys[0].uid",
    minWidth: 300,
  },
  {
    Header: "Name",
    accessor: (row: any) => row.lead?.customer.name,
    minWidth: 240,
    isSortable: true,
  },
  {
    Header: "Unit Value",
    accessor: (row: any) => {
      if (row.unitValue) {
        return row.unitValue.toLocaleString();
      }

      if (row.expectedValue) {
        return row.expectedValue.toLocaleString();
      }

      return "";
    },
    minWidth: 150,
    isSortable: true,
  },
  {
    Header: "Agent",
    accessor: (row: any) => ({
      name: row.agent?.name,
      color: row.agent?.color,
    }),
    minWidth: 210,
    isSortable: true,
  },
  {
    Header: "Location",
    accessor: (row: any) => row.unitLocation,
    minWidth: 210,
    isSortable: true,
  },
  {
    Header: "Compound",
    accessor: (row: any) => row.compound?.name,
    minWidth: 210,
    isSortable: true,
  },
  {
    Header: "Organization",
    accessor: (row: any) =>
      row.organization.name.charAt(0).toUpperCase() +
      row.organization.name.slice(1),
    minWidth: 210,
    isSortable: true,
  },
];

export const tabOptions: SaleTypeName[] = [
  "Contracted",
  "EOI",
  "Reserved",
  "Blocked",
];

export const RADIAN = Math.PI / 180;
export const data = [
  { name: "A", value: 25, color: "#F04438" },
  { name: "B", value: 25, color: "#F79009" },
  { name: "C", value: 25, color: "#FAB55A" },
  { name: "D", value: 25, color: "#41C588" },
];
export const cx = 100;
export const cy = 100;
export const iR = 75;
export const oR = 100;

export const targetDetailsLabelsMap: Map<SaleTypeName, string> = new Map();
targetDetailsLabelsMap.set("Contracted", "Sales Details");
targetDetailsLabelsMap.set("EOI", "EOI Details");
targetDetailsLabelsMap.set("Blocked", "Unit Blocked Details");
targetDetailsLabelsMap.set("Reserved", "Reserved Details");

export const targetTypeOptions = [
  { label: "GMV", value: TargetTypes.GMV },
  { label: "Revenue", value: TargetTypes.REVENUE },
  { label: "Loan Amount", value: TargetTypes.LOAN_AMOUNT },
];

export const targetTypeLabels: Record<TargetTemplateType, string> = {
  [TargetTemplateType.PERSONAL]: "Personal Target",
  [TargetTemplateType.MINIMUM]: "Minimum Target",
};
